// removed by extract-text-webpack-plugin
module.exports = {"root":"ProgressBar__root___2ZO3s","progress":"ProgressBar__progress___qmE5G","progressBar":"ProgressBar__progressBar___2zl7p","info":"ProgressBar__info___3thsg"};


//////////////////
// WEBPACK FOOTER
// ./src/components/ProgressBar.scss
// module id = 591
// module chunks = 1